import {SupportLink, SupportLinkRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {dateToString} from "../../../../components/utils/dates";
import {SoftChip} from "../../../../components/kit";

export const SupportLinkListPage = () => {
	const apiManager = useApiManager();


	const listConfig: AppListConfig<SupportLink> = {
		title: "Enlaces de valoración de clientes",
		onClick: "/app/admin/compliance/supportlink",
		headers: [
			{title: "Creado"},
			{title: "Nombre"},
			{title: "Evaluado"},
		],
		decorator: (bean: SupportLink) => (
			<>
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : "inherit"}}>
					{dateToString(bean.created)}
				</TableCell>
				<TableCell>
					{bean.name}
				</TableCell>
				<TableCell>
					{bean.evaluationDate
						? <SoftChip tone="success" label={"Respondido el " + dateToString(bean.evaluationDate)}/>
						: <SoftChip tone="warning" label="Pendiente"/>}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(SupportLinkRestControllerApiFactory);
			return ctrl.pageSupportLink(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};